/**
 * Temporary translation helper.
 * Returns the Spanish string from a { en, es } object.
 * When a full LanguageProvider is added to the app,
 * replace usages with useTranslation() hook.
 */
export const t = (obj) => obj.es ?? obj.en ?? '';
